import { Component } from "@angular/core";
import {
  Router,
  ResolveStart,
  ResolveEnd,
  NavigationEnd,
  Scroll,
  Event,
  RouterOutlet,
} from "@angular/router";
import { filter } from "rxjs/operators";
import { ViewportScroller, NgIf } from "@angular/common";
import { MatProgressSpinner } from "@angular/material/progress-spinner";
import { FooterComponent } from "../footer/footer.component";
import { CookiesBannerComponent } from "../../shared/component/cookies-banner/cookies-banner.component";
import { PublicHeaderComponent } from "./public-header/public-header.component";

@Component({
  selector: "app-public-layout",
  templateUrl: "./public-layout.component.html",
  styleUrls: ["./public-layout.component.scss"],
  imports: [
    NgIf,
    MatProgressSpinner,
    PublicHeaderComponent,
    RouterOutlet,
    FooterComponent,
    CookiesBannerComponent,
  ],
})
export class PublicLayoutComponent {
  public loading = false;
  constructor(
    private router: Router,
    private viewportScroller: ViewportScroller,
  ) {
    this.router.events.subscribe((e: Event) => {
      switch (true) {
        case e instanceof ResolveStart: {
          this.loading = true;
          break;
        }

        case e instanceof ResolveEnd:
        case e instanceof NavigationEnd: {
          this.loading = false;
          break;
        }

        default: {
          break;
        }
      }
    });

    this.router.events.pipe(filter((e) => e instanceof Scroll)).subscribe((e: any) => {
      setTimeout(() => {
        if (e.position) {
          this.viewportScroller.scrollToPosition(e.position);
        } else if (e.anchor) {
          this.viewportScroller.scrollToAnchor(e.anchor);
        } else {
          this.viewportScroller.scrollToPosition([0, 0]);
        }
      });
    });
  }
}
